import { useState } from "react"
import clsx from "clsx"
import fastdom from "fastdom"

import { useIsoLayoutEffect } from "~/utils/hooks/useIsoLayoutEffect"

export const ScrollProgressBar: React.FC = () => {
  const [progress, setProgress] = useState(0)

  useIsoLayoutEffect(() => {
    const updateScrollProgress = () => {
      fastdom.measure(() => {
        const scrollableHeight =
          document.body.clientHeight - window.screen.height
        const y = window.scrollY

        setProgress((100 / scrollableHeight) * y)
      })
    }

    window.addEventListener("scroll", updateScrollProgress)

    return () => window.removeEventListener("scroll", updateScrollProgress)
  }, [])

  return (
    <div
      className={clsx(
        "fixed top-0 left-0 z-20",
        "bg-primary-500 dark:bg-secondary-500",
      )}
      style={{ width: `${progress}%`, height: 6 }}
    />
  )
}
